// Central configuration for the Karito Educa sales letter.

// Checkout / CTA destination.
export const CHECKOUT_URL =
  'https://colorpack.online/cart/48298847993995:1?storefront=true'

// Countdown length in seconds -> 00:17:34
export const COUNTDOWN_SECONDS = 17 * 60 + 34

// Scarcity: cupos restantes al precio promocional.
export const SPOTS_TOTAL = 50
export const SPOTS_LEFT = 7

export const PRICE = '$14.99 USD'
export const PRICE_TOTAL_VALUE = 'USD 218'
